import type { BaseEntity } from '../base-entity.interface';

import type { CsvIntegrationConfig } from './csv-integration-config.interface';
import { IntegrationCredentials } from './integration-credentials.entity';
import { IntegrationProductFlags } from './integration-product-flags.entity';
import type { SfccIntegrationConfig } from './sfcc-integration-config.interface';
export class Integration implements BaseEntity {
  EmbeddingFontFamily?: string;
  apiToken: string;
  apiUrl: string;
  cartPath: string;
  createdAt!: Date;
  createdBy!: string;
  credentials: IntegrationCredentials;
  cronScheduledSync: string;
  cronScheduledSyncTimezone?: string;
  csvIntegrationConfig?: CsvIntegrationConfig;
  customerStoreId: string;
  enableAllProducts: boolean;
  extraProductIds?: string;
  headerElements: string;
  id!: string;
  integrationClass: string;
  productCatalogUrl: string;
  productFlags: IntegrationProductFlags;
  productIds: string[];
  productUniqueIdFieldName: string;
  productVariantUniqueIdFieldName: string;
  sfccIntegrationConfig?: SfccIntegrationConfig;
  shopifyApp?: {
    isEmbedBlockActive?: boolean;
    welcomeEmailSentAt?: Date;
  };
  storeId!: string;
  storefrontLanguage?: string;
  updatedAt!: Date;
  updatedBy!: string;
  websiteUrl: string;
  constructor(attrs?: Partial<Integration>) {
    Object.assign(this, attrs);
    this.apiToken = attrs?.apiToken ?? '';
    this.apiUrl = attrs?.apiUrl ?? '';
    this.productCatalogUrl = attrs?.productCatalogUrl ?? '';
    this.websiteUrl = attrs?.websiteUrl ?? '';
    this.customerStoreId = attrs?.customerStoreId ?? '';
    this.headerElements = attrs?.headerElements ?? '';
    this.integrationClass = attrs?.integrationClass ?? 'BaseGeneric';
    this.cartPath = attrs?.cartPath ?? 'checkout';
    this.cronScheduledSync = attrs?.cronScheduledSync ?? 'None';
    this.cronScheduledSyncTimezone = attrs?.cronScheduledSyncTimezone;
    this.productUniqueIdFieldName = attrs?.productUniqueIdFieldName ?? 'id';
    this.productVariantUniqueIdFieldName = attrs?.productVariantUniqueIdFieldName ?? 'sku';
    this.productIds = attrs?.productIds ?? [];
    this.enableAllProducts = attrs?.enableAllProducts ?? false;
    this.credentials = Object.assign(new IntegrationCredentials(), attrs?.credentials);
    this.productFlags = new IntegrationProductFlags(attrs?.productFlags);
  }
}
